<template>
  <!-- With the softphone on, the number itself places the call; otherwise it is
       shown exactly as before. -->
  <button
    v-if="callable"
    v-bind="$attrs"
    type="button"
    class="inline-flex cursor-pointer items-center border-0 bg-transparent p-0 text-left text-blue-600 hover:underline"
    :aria-label="`Call ${phoneNumber} with Dialpad`"
    :title="`Call ${phoneNumber} with Dialpad`"
    data-cy="dialpad-phone-link"
    @click.stop.prevent="call"
  >
    <i
      class="fa-regular fa-phone-arrow-up-right mr-1 text-xs"
      aria-hidden="true"
    />{{ phoneNumber }}
  </button>
  <template v-else>{{ phoneNumber }}</template>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { toE164 } from "@/lib/dialpadCti";

import {
  type DialpadCallSource,
  useDialpadContext,
  useSoftphoneEnabled
} from "@/composables/useDialpadContext";

defineOptions({ inheritAttrs: false });

const props = defineProps<{
  phoneNumber: string | null | undefined;
  source: DialpadCallSource;
  sourceId: number;
}>();

const softphoneEnabled = useSoftphoneEnabled();
const callable = computed(
  () => softphoneEnabled.value && toE164(props.phoneNumber) !== null
);

const { startCall } = useDialpadContext();

const call = () => {
  if (props.phoneNumber) {
    startCall(props.phoneNumber, {
      source: props.source,
      sourceId: props.sourceId
    });
  }
};
</script>
